import {
  IonButton,
  IonImg
} from '@ionic/react';
import React from 'react';
import { FadeText } from '../ui/fade-text';


const BottomCTA: React.FC = () => {
  return (
    <div className="mx-auto w-full p-8 py-16 md:max-w-6xl">
      <div className="relative overflow-hidden rounded-3xl bg-green-800 shadow-2xl">
        <div className="absolute size-full" style={{ willChange: 'auto' }}>
          <IonImg
            alt="golf background"
            src="/assets/images/winter.jpg"
            className="absolute"
          />
          <div className="absolute inset-0 bg-green-800/80"></div>
        </div>
        <div className="relative flex items-center justify-center px-6 py-16 md:py-24 lg:px-12 lg:py-36">
          {/* Content Wrapper */}
          <div className="w-full space-y-6 text-left">
            {/* Heading */}
            <h1 className="text-3xl font-bold tracking-tight text-white md:text-5xl">
              <FadeText
                direction="up"
                framerProps={{
                  show: { transition: { delay: 0 } },
                }}
                text="Ready to tee off?"
              />
            </h1>

            {/* Input and Button Section */}
            <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
              {/* Button */}
              <IonButton
                type="button"
                shape="round"
                className="h-14 whitespace-nowrap text-base"
                routerLink={'/welcome'}

              >
                Start your journey
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomCTA;
